import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { BexioBusinessYear, BexioConnectionStatusDto, BexioImportResult } from '../services/bexio.service';

export const bexioActions = createActionGroup({
    source: 'Bexio',
    events: {
        // Load connection status
        'Load Connection': props<{ companyId: string }>(),
        'Load Connection Success': props<{ connection: BexioConnectionStatusDto | null }>(),
        'Load Connection Failure': props<{ error: HttpErrorResponse }>(),

        // Load available business years
        'Load Business Years': props<{ companyId: string }>(),
        'Load Business Years Success': props<{ businessYears: BexioBusinessYear[] }>(),
        'Load Business Years Failure': props<{ error: HttpErrorResponse }>(),

        // Connect (opens OAuth popup)
        'Connect': props<{ companyId: string }>(),
        'Connect Success': props<{ companyId: string }>(),
        'Connect Failure': props<{ error: HttpErrorResponse }>(),

        // Disconnect
        'Disconnect': props<{ companyId: string }>(),
        'Disconnect Success': emptyProps(),
        'Disconnect Failure': props<{ error: HttpErrorResponse }>(),

        // Import data
        'Import Data': props<{ companyId: string; annualReportId: string; businessYearId: number; previousBusinessYearId?: number; annualReportMetaInfoId?: string }>(),
        'Import Data Success': props<{ result: BexioImportResult }>(),
        'Import Data Failure': props<{ error: HttpErrorResponse }>(),

        // Reset import state (e.g. when leaving the page)
        'Reset Import': emptyProps(),

        // Cancel an in-progress connect flow (e.g. user navigates away)
        'Cancel Connect': emptyProps(),
    },
});
